module.exports = __webpack_public_path__ + "static/img/4.450b80e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/sp/4.png
// module id = A/b3
// module chunks = 0